export default {
    main: '#D51D4C',
};
